/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Notavailable1Inputs */

const id_common_notavailable1 = /** @type {(inputs: Common_Notavailable1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tidak tersedia`)
};

const ms_common_notavailable1 = /** @type {(inputs: Common_Notavailable1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tidak tersedia`)
};

const da_common_notavailable1 = /** @type {(inputs: Common_Notavailable1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ikke tilgængelig`)
};

const de_common_notavailable1 = /** @type {(inputs: Common_Notavailable1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nicht verfügbar`)
};

const en_us2_common_notavailable1 = /** @type {(inputs: Common_Notavailable1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Not available`)
};

const es_es2_common_notavailable1 = /** @type {(inputs: Common_Notavailable1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No disponible`)
};

const es_mx2_common_notavailable1 = /** @type {(inputs: Common_Notavailable1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No disponible`)
};

const fil_common_notavailable1 = /** @type {(inputs: Common_Notavailable1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hindi available`)
};

const fr_common_notavailable1 = /** @type {(inputs: Common_Notavailable1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Non disponible`)
};

const it_common_notavailable1 = /** @type {(inputs: Common_Notavailable1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Non disponibile`)
};

const hu_common_notavailable1 = /** @type {(inputs: Common_Notavailable1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nem elérhető`)
};

const nl_common_notavailable1 = /** @type {(inputs: Common_Notavailable1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Niet beschikbaar`)
};

const no_common_notavailable1 = /** @type {(inputs: Common_Notavailable1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ikke tilgjengelig`)
};

const pl_common_notavailable1 = /** @type {(inputs: Common_Notavailable1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Niedostępne`)
};

const pt_br2_common_notavailable1 = /** @type {(inputs: Common_Notavailable1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não disponível`)
};

const pt_common_notavailable1 = /** @type {(inputs: Common_Notavailable1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não disponível`)
};

const ro_common_notavailable1 = /** @type {(inputs: Common_Notavailable1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Indisponibil`)
};

const fi_common_notavailable1 = /** @type {(inputs: Common_Notavailable1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ei saatavilla`)
};

const sv_common_notavailable1 = /** @type {(inputs: Common_Notavailable1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inte tillgänglig`)
};

const vi_common_notavailable1 = /** @type {(inputs: Common_Notavailable1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Không khả dụng`)
};

const tr_common_notavailable1 = /** @type {(inputs: Common_Notavailable1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kullanılamıyor`)
};

const cs_common_notavailable1 = /** @type {(inputs: Common_Notavailable1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Není k dispozici`)
};

const bg_common_notavailable1 = /** @type {(inputs: Common_Notavailable1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Не е налично`)
};

const ru_common_notavailable1 = /** @type {(inputs: Common_Notavailable1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Недоступно`)
};

const uk_common_notavailable1 = /** @type {(inputs: Common_Notavailable1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Недоступно`)
};

const ar_common_notavailable1 = /** @type {(inputs: Common_Notavailable1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`غير متوفر`)
};

const hi_common_notavailable1 = /** @type {(inputs: Common_Notavailable1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`उपलब्ध नहीं`)
};

const th_common_notavailable1 = /** @type {(inputs: Common_Notavailable1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ไม่พร้อมใช้งาน`)
};

const ja_common_notavailable1 = /** @type {(inputs: Common_Notavailable1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`利用不可`)
};

const zh_cn2_common_notavailable1 = /** @type {(inputs: Common_Notavailable1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`不可用`)
};

const zh_hant1_common_notavailable1 = /** @type {(inputs: Common_Notavailable1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`無法使用`)
};

const ko_common_notavailable1 = /** @type {(inputs: Common_Notavailable1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`사용할 수 없음`)
};

/**
* | output |
* | --- |
* | "Not available" |
*
* @param {Common_Notavailable1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const common_notavailable1 = /** @type {((inputs?: Common_Notavailable1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Notavailable1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_common_notavailable1(inputs)
	if (locale === "ms") return ms_common_notavailable1(inputs)
	if (locale === "da") return da_common_notavailable1(inputs)
	if (locale === "de") return de_common_notavailable1(inputs)
	if (locale === "en-US") return en_us2_common_notavailable1(inputs)
	if (locale === "es-ES") return es_es2_common_notavailable1(inputs)
	if (locale === "es-MX") return es_mx2_common_notavailable1(inputs)
	if (locale === "fil") return fil_common_notavailable1(inputs)
	if (locale === "fr") return fr_common_notavailable1(inputs)
	if (locale === "it") return it_common_notavailable1(inputs)
	if (locale === "hu") return hu_common_notavailable1(inputs)
	if (locale === "nl") return nl_common_notavailable1(inputs)
	if (locale === "no") return no_common_notavailable1(inputs)
	if (locale === "pl") return pl_common_notavailable1(inputs)
	if (locale === "pt-BR") return pt_br2_common_notavailable1(inputs)
	if (locale === "pt") return pt_common_notavailable1(inputs)
	if (locale === "ro") return ro_common_notavailable1(inputs)
	if (locale === "fi") return fi_common_notavailable1(inputs)
	if (locale === "sv") return sv_common_notavailable1(inputs)
	if (locale === "vi") return vi_common_notavailable1(inputs)
	if (locale === "tr") return tr_common_notavailable1(inputs)
	if (locale === "cs") return cs_common_notavailable1(inputs)
	if (locale === "bg") return bg_common_notavailable1(inputs)
	if (locale === "ru") return ru_common_notavailable1(inputs)
	if (locale === "uk") return uk_common_notavailable1(inputs)
	if (locale === "ar") return ar_common_notavailable1(inputs)
	if (locale === "hi") return hi_common_notavailable1(inputs)
	if (locale === "th") return th_common_notavailable1(inputs)
	if (locale === "ja") return ja_common_notavailable1(inputs)
	if (locale === "zh-CN") return zh_cn2_common_notavailable1(inputs)
	if (locale === "zh-Hant") return zh_hant1_common_notavailable1(inputs)
	return ko_common_notavailable1(inputs)
});
export { common_notavailable1 as "common.notAvailable" }